var $ = require('jquery');
require('slick-carousel');


$('.slider')
  .slick({
    dots: true,
    arrows: true,
    speed: 800,
    autoplay: true,
    cssEase: 'cubic-bezier(.16,.66,.3,.99)',
    // slidesToShow: 3,
    // slidesToScroll: 1,
    infinite: true,
    // autoplay: true
  })


$( document ).ready(function() {

  // Default Slider
  $('.js-dd-slider').each(function() {
      var currentSlider = $(this);
      var sliderLayout        = currentSlider.attr('data-slideitems');
      var sliderDots          = currentSlider.attr('data-sliderdots');
      if (sliderDots == "true") {
        var sliderDotsValue = true;
      }

      currentSlider.slick({
        dots: sliderDotsValue,
        arrows: true,
        speed: 800,
        autoplay: false,
        cssEase: 'cubic-bezier(.16,.66,.3,.99)',
        slidesToShow: sliderLayout,
        slidesToScroll: 1,
        infinite: false,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1
            }
          }
        ]
    })
  });
});


// Infoslider
$('.dd-infoslider')
  .slick({
    dots: true,
    arrows: true,
    speed: 800,
    fade: true,
    autoplay: true,
    cssEase: 'cubic-bezier(.16,.66,.3,.99)',
    slidesToShow: 1,
    // slidesToScroll: 1,
    infinite: true,
    // autoplay: true
  })


// Highlights
$('.dd-highlight')
  .slick({
    dots: true,
    arrows: true,
    speed: 800,
    fade: true,
    autoplay: true,
    cssEase: 'cubic-bezier(.16,.66,.3,.99)',
    slidesToShow: 1,
    // slidesToScroll: 1,
    infinite: true,
    // autoplay: true
  })


$('.js-dd-slider--equip').each(function() {
    var currentSlider = $(this);
    var sliderLayout        = currentSlider.attr('data-slideitems');
    var sliderDots          = currentSlider.attr('data-sliderdots');
    if (sliderDots == "true") {
      var sliderDotsValue = true;
    }

    currentSlider.slick({
      dots: sliderDotsValue,
      arrows: true,
      speed: 800,
      autoplay: false,
      cssEase: 'cubic-bezier(.16,.66,.3,.99)',
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
  })
});

